import axiosTokenInstance from 'services/api/backoffice';
import { IPB_PACKAGE_BY_CHANNEL, IPB_PACKAGE_BY_CHANNEL_ERROR } from '_models/redux/types';

// Action function
export const getIpbPackageByChannelAction = (params) => async (dispatch) => {
  const { from_time, to_time } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `api/marketing/report-pakage-sales?from_date=${from_time}&to_date=${to_time}`,
    );

    const { data, status } = response || {};

    dispatch({
      method: 'get',
      payload: data || {},
      status: status || {},
      type: IPB_PACKAGE_BY_CHANNEL,
    });
  } catch (e) {
    dispatch({
      method: 'get',
      payload: e || {},
      type: IPB_PACKAGE_BY_CHANNEL_ERROR,
    });
  }
};
